import { UserManager } from "oidc-client-ts";
import type { AuthProviderProps } from "react-oidc-context";

// Called after the OIDC callback is processed — cleans the code/state params
// from the URL so the router doesn't see them as a page change.
function onSigninCallback(): void {
  window.history.replaceState({}, document.title, window.location.pathname);
}

const oidcSettings = {
  authority: import.meta.env.VITE_KEYCLOAK_AUTHORITY,
  client_id: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_REDIRECT_URI,
  post_logout_redirect_uri: import.meta.env.VITE_POST_LOGOUT_URI,
  scope: "openid profile email",
  response_type: "code",
  loadUserInfo: false,
  silent_redirect_uri: `${window.location.origin}/silent-renew.html`,
};

// Single UserManager instance — guarantees only one set of event listeners
// (accessTokenExpiring etc.) regardless of how many times AuthProvider mounts.
export const userManager = new UserManager(oidcSettings);

export const authConfig: AuthProviderProps = {
  userManager,
  onSigninCallback,
};
